import React, { useRef, useState } from "react";
import { Tooltip } from "reactstrap";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import styles from "./style.module.scss";

const TooltipIcon = (props) => {
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const { children } = props;
    const tooltipRef = useRef(null);

    const toggle = () => {
        setTooltipOpen(!tooltipOpen);
    }
    
    return (
        <>
            <InfoOutlinedIcon className={styles.tooltipIcon} ref={tooltipRef} />
            <Tooltip placement="bottom" isOpen={tooltipOpen} target={tooltipRef} toggle={toggle}>
                {children}
            </Tooltip>
        </>
    );
}

export default TooltipIcon;